/* =============================================================
   HappyHours custom cart drawer — self-contained shell for Horizon
   Replaces Prestige's <cart-drawer> web component (which lived in
   theme.js and was NOT ported). Light-DOM: open/close + overlay.
   Opening logic + add-to-cart interception lives here; line-item
   remove/qty/subscription logic lives in cart-drawer-ajax.js.
   ============================================================= */
(function () {
  'use strict';

  class HHCartDrawer extends HTMLElement {
    connectedCallback() {
      if (this._wired) return;
      this._wired = true;

      // Build / reuse the backdrop overlay
      let ov = document.querySelector('.hh-cart-overlay');
      if (!ov) {
        ov = document.createElement('div');
        ov.className = 'hh-cart-overlay';
        document.body.appendChild(ov);
      }
      this._overlay = ov;
      ov.addEventListener('click', () => this.close());

      // Close button(s) inside the drawer
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-cart-close]')) this.close();
      });
    }

    open() {
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      if (this._overlay) this._overlay.classList.add('is-open');
      document.documentElement.classList.add('hh-cart-open');
    }

    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      if (this._overlay) this._overlay.classList.remove('is-open');
      document.documentElement.classList.remove('hh-cart-open');
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', HHCartDrawer);
  }

  function getDrawer() {
    return document.querySelector('cart-drawer#cart-drawer');
  }

  // ESC closes
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    const d = getDrawer();
    if (d && d.classList.contains('is-open')) d.close();
  });

  // Intercept the header cart icon / cart links → open OUR drawer.
  // Capture phase + stopImmediatePropagation to beat Horizon's native handlers.
  document.addEventListener(
    'click',
    function (e) {
      const trigger = e.target.closest(
        'cart-icon, a[href$="/cart"], a[href*="/cart?"], [data-cart-open]'
      );
      if (!trigger) return;
      const d = getDrawer();
      if (!d) return; // no custom drawer present → let default happen
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      d.open();
    },
    true
  );

  // Expose a global opener for other scripts (cart-drawer-ajax.js add hook)
  window.HHCartDrawerOpen = function () {
    const d = getDrawer();
    if (d) d.open();
  };

  // ---------------------------------------------------------------------------
  // Safety net: neutralize Horizon's native <cart-drawer-component> if it is
  // still present (e.g. an edge-cached page rendered before the header-actions
  // change propagated, or a delegated-handler race). We no-op its open methods
  // so it can NEVER appear as a second cart on top of ours.
  // ---------------------------------------------------------------------------
  function neutralizeHorizonCartDrawer() {
    var nodes = document.querySelectorAll('cart-drawer-component');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.__hhNeutralized) continue;
      el.__hhNeutralized = true;
      var noop = function () {};
      try {
        Object.defineProperty(el, 'open', { value: noop, configurable: true });
        Object.defineProperty(el, 'showDialog', { value: noop, configurable: true });
      } catch (e) {
        try { el.open = noop; el.showDialog = noop; } catch (e2) {}
      }
      var dlg = el.querySelector ? el.querySelector('dialog') : null;
      if (dlg) { try { if (dlg.open) dlg.close(); } catch (e3) {} }
    }
  }
  neutralizeHorizonCartDrawer();
  document.addEventListener('DOMContentLoaded', neutralizeHorizonCartDrawer);
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer-component').then(function () {
      neutralizeHorizonCartDrawer();
      setTimeout(neutralizeHorizonCartDrawer, 300);
    });
  }
  setTimeout(neutralizeHorizonCartDrawer, 1200);
})();
